import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthService } from '../../api-authorization/authorize.service';


@Component({
  selector: 'app-login',
  templateUrl: './user-login.component.html',
  styleUrls: ['./user-login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;

  isLoading = false;

  error: string | null = null;

  hide = true;


  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {

    this.loginForm =
      this.fb.group({

        email: [
          '',
          [
            Validators.required,
            Validators.email
          ]
        ],

        password: [
          '',
          Validators.required
        ]

      });
  }


  ngOnInit(): void {

    const savedEmail =
      localStorage.getItem('savedEmail');

    if (savedEmail) {

      this.loginForm.patchValue({
        email: savedEmail
      });
    }
  }


  // ========================================================
  // LOGIN
  // ========================================================

  onSubmit(): void {

    this.error = null;


    /*
     * Nicht versuchen einzuloggen, solange das Formular
     * ungültig ist.
     *
     * Wichtig:
     * Vorher wurde isLoading schon auf true gesetzt und bei
     * einem ungültigen Formular nie wieder zurückgesetzt.
     */
    if (this.loginForm.invalid) {

      this.loginForm.markAllAsTouched();

      return;
    }


    this.isLoading = true;


    const loginData =
      this.loginForm.value;


    this.authService
      .login(
        loginData.email,
        loginData.password
      )
      .subscribe({

        next: response => {

          localStorage.setItem(
            'savedEmail',
            loginData.email
          );


          const returnUrl =
            this.getReturnUrl();


          /*
           * Beim ersten Login muss zuerst das Passwort
           * geändert werden.
           *
           * Den ursprünglichen returnUrl nehmen wir dabei
           * mit zur Passwortänderungsseite, damit danach
           * ebenfalls wieder zur ursprünglichen Messstelle
           * zurückgesprungen werden kann.
           */
          if (response.firstLogin) {

            this.router.navigate(
              ['/changepassword'],
              {
                queryParams: {
                  returnUrl
                }
              }
            );

          } else {

            /*
             * Normaler Login:
             *
             * QR-Link:
             * /users/login?returnUrl=/q/m/ABC123
             *
             * führt danach wieder zu:
             * /q/m/ABC123
             *
             * Ohne returnUrl geht es wie bisher auf /home.
             */
            this.router.navigateByUrl(
              returnUrl
            );
          }


          this.isLoading = false;
        },


        error: error => {

          console.error(
            'Login fehlgeschlagen:',
            error
          );


          this.error =
            'Ungültige Anmeldedaten. Bitte überprüfen Sie Ihre Eingaben.';

          this.isLoading = false;
        }

      });
  }


  // ========================================================
  // RÜCKSPRUNG NACH LOGIN
  // ========================================================

  private getReturnUrl(): string {

    const returnUrl =
      this.route.snapshot.queryParamMap
        .get('returnUrl');


    /*
     * Nur interne Angular-URLs erlauben.
     *
     * Dadurch kann z. B. kein Link wie
     * https://fremde-seite.at
     * als Rücksprungziel eingeschleust werden.
     */
    if (
      returnUrl
      &&
      returnUrl.startsWith('/')
      &&
      !returnUrl.startsWith('//')
    ) {

      return returnUrl;
    }


    /*
     * Normales Verhalten, wenn die Login-Seite
     * direkt geöffnet wurde.
     */
    return '/home';
  }
}